import React, { useMemo } from 'react';
import { GeoJSONProperties } from '../../hooks/useDealershipList';
import CTA from '../Button';
import { CTA_LIST } from '../../constants/CtaList';
import POI from '../../assets/icons/POI';
import PhoneIcon from '../../assets/icons/PhoneIcon';
import EmailIcon from '../../assets/icons/EmailIcon';
import { DetailsContainer, DetailItem, Title, Link } from './DealerInfo.styles';

interface DealerInfoProps {
  onClose: () => void;
  dealerInfo: GeoJSON.Feature<GeoJSON.Point, GeoJSONProperties>;
}

const DealerInfo: React.FC<DealerInfoProps> = ({ onClose, dealerInfo }) => {
  const dealerAddress = useMemo(() => {
    const { street, city, region, zipCode } = dealerInfo.properties.address;
    return `${street}, ${city}, ${region}, ${zipCode}`;
  }, [dealerInfo]);

  return (
    <div>
      <CTA onChange={onClose} buttonType={CTA_LIST.BACK_TO_RADIUS} />
      <DetailsContainer>
        <DetailItem>
          <Title>{dealerInfo.properties.name}</Title>
        </DetailItem>
        <DetailItem>
          <POI />
          {dealerAddress}
        </DetailItem>
        {!!dealerInfo.properties.phone && (
          <DetailItem>
            <Link href={dealerInfo.properties.phoneURL}>
              <PhoneIcon />
              {dealerInfo?.properties?.phone}
            </Link>
          </DetailItem>
        )}
        {!!dealerInfo.properties.email && (
          <DetailItem>
            <Link href={`mailto:${dealerInfo.properties.email}`}>
              <EmailIcon />
              {dealerInfo?.properties?.email}
            </Link>
          </DetailItem>
        )}
      </DetailsContainer>
    </div>
  );
};

export default DealerInfo;
